module.exports = __webpack_public_path__ + "static/img/5.ab8eae83.png";